import React, { useCallback, useEffect, useState } from 'react';
import { format, parse } from 'date-fns';
import { SettingsItemNavigate } from 'design-system';
import { IconBoldCalendar, IconProfile } from 'design-system/icons';
import { IconGender } from 'design-system/icons/IconGender';
import useDateTimePickerDOB, { DOB_DISPLAY_FORMAT, DOB_STORAGE_FORMAT, } from 'hooks/useDateTimePickerDOB';
import { registerUser } from 'actions';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { selectUser } from 'reducers/selectors';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { TitleModal } from 'features/borrow/components/monevo/TitleModal';
import { TITLES } from 'features/borrow/monevo/models';
const strings = {
    titleRow: 'Title',
    firstName: 'Legal first name',
    middleName: 'Legal middle name (optional)',
    lastName: 'Legal last name',
    dob: 'Date of birth',
    defaultTitle: 'Choose...',
};
const CreditScorePersonalDetailsSection = ({ onDobChange }) => {
    const user = useAppSelector(selectUser);
    const dispatch = useAppDispatch();
    const navigation = useMainStackNavigation();
    const areFieldsDisabled = Boolean(user.kycStartedAt || user.creditScoreIdentityLockedAt);
    const [title, setTitle] = useState(user?.title ?? '');
    const [firstName, setFirstName] = useState(user?.firstName ?? '');
    const [middleName, setMiddleName] = useState(user?.middleName ?? '');
    const [lastName, setLastName] = useState(user?.lastName ?? '');
    const { showDateTimePicker, dob } = useDateTimePickerDOB(user, 0);
    useEffect(() => {
        onDobChange?.(dob);
    }, [dob, onDobChange]);
    const titleLabel = TITLES.find((t) => t.value === title)?.label || strings.defaultTitle;
    const openTitle = useCallback(() => {
        TitleModal.show((titleObj) => {
            setTitle(titleObj.value);
            dispatch(registerUser({ title: titleObj.value }));
        });
    }, []);
    const changeName = useCallback(() => {
        navigation.navigate('ChangeDetail', {
            key: 'firstName',
            defaultValue: firstName,
            onSuccess: setFirstName,
        });
    }, [firstName]);
    const changeMiddleName = useCallback(() => {
        navigation.navigate('ChangeDetail', {
            key: 'middleName',
            defaultValue: middleName,
            onSuccess: setMiddleName,
        });
    }, [middleName]);
    const changeLastName = useCallback(() => {
        navigation.navigate('ChangeDetail', {
            key: 'lastName',
            defaultValue: lastName,
            onSuccess: setLastName,
        });
    }, [lastName]);
    return (<>
      <SettingsItemNavigate icon={<IconGender gradientKey="lightPurple"/>} description={strings.titleRow} title={titleLabel} onPress={openTitle} isSelected={false}/>
      <SettingsItemNavigate icon={<IconProfile gradientKey="darkPurple"/>} disabled={areFieldsDisabled} description={strings.firstName} title={firstName || strings.defaultTitle} onPress={changeName}/>
      <SettingsItemNavigate icon={<IconProfile gradientKey="lightPink"/>} disabled={areFieldsDisabled} description={strings.middleName} title={middleName || strings.defaultTitle} onPress={changeMiddleName}/>
      <SettingsItemNavigate icon={<IconProfile gradientKey="skyBlue"/>} disabled={areFieldsDisabled} description={strings.lastName} title={lastName || strings.defaultTitle} onPress={changeLastName}/>
      <SettingsItemNavigate icon={<IconBoldCalendar gradientKey="darkPurple"/>} disabled={areFieldsDisabled ? Boolean(dob) : undefined} title={dob
            ? format(parse(dob, DOB_STORAGE_FORMAT, new Date()), DOB_DISPLAY_FORMAT)
            : strings.defaultTitle} description={strings.dob} onPress={showDateTimePicker} isSelected={false}/>
    </>);
};
export default CreditScorePersonalDetailsSection;
